import { render, staticRenderFns } from "./SubHireInvoiceUpdatedList.vue?vue&type=template&id=58c5606e"
import script from "./SubHireInvoiceUpdatedList.vue?vue&type=script&lang=js"
export * from "./SubHireInvoiceUpdatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports